/**
 * Yumwoof PDP gallery.
 * On desktop the gallery shows one image at a time in a square card (see
 * css--pdp-custom.css: images are stacked, only .is-active is visible).
 *
 * Dawn's slider-component blocks native scroll on desktop and mis-computes its
 * counter in the stacked layout (NaN), and its button handler reverts the image.
 * So we hide Dawn's slider-buttons and render our own counter + arrows, which
 * switch the image via the gallery's own setActiveMedia() (verified to work).
 */
(function () {
  function initGallery(gallery) {
    if (!gallery || gallery.dataset.ywGallery) return;
    var mediaItems = gallery.querySelectorAll('.product__media-item');
    if (mediaItems.length === 0) return;
    gallery.dataset.ywGallery = '1';

    var nav = document.createElement('div');
    nav.className = 'yw-gallery-nav';
    nav.innerHTML =
    '<span class="yw-gallery-counter"><span class="yw-gallery-current">1</span> / <span class="yw-gallery-total"></span></span>' +
    '<div class="yw-gallery-pagination"></div>' +
    '<button type="button" class="yw-gallery-btn yw-gallery-prev" aria-label="Previous image"><svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.45677 10C7.09774 9.17355 6.72491 8.44353 6.33826 7.80992C5.95161 7.14876 5.56496 6.58402 5.17832 6.1157H20V3.8843H5.17832C5.56496 3.38843 5.95161 2.82369 6.33826 2.19008C6.72491 1.52893 7.09774 0.798898 7.45677 0H5.50973C3.76981 2.01102 1.93324 3.49862 0 4.46281V5.53719C1.93324 6.47383 3.76981 7.96143 5.50973 10H7.45677Z" fill="#FFF9EF" /></svg></button>' +
    '<button type="button" class="yw-gallery-btn yw-gallery-next" aria-label="Next image"><svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5432 10C12.9023 9.17355 13.2751 8.44353 13.6617 7.80992C14.0484 7.14876 14.435 6.58402 14.8217 6.1157H0V3.8843H14.8217C14.435 3.38843 14.0484 2.82369 13.6617 2.19008C13.2751 1.52893 12.9023 0.798898 12.5432 0H14.4903C16.2302 2.01102 18.0668 3.49862 20 4.46281V5.53719C18.0668 6.47383 16.2302 7.96143 14.4903 10H12.5432Z" fill="#FFF9EF"/></svg></button>';
    gallery.appendChild(nav);
    var pagination = nav.querySelector('.yw-gallery-pagination');
    var current = nav.querySelector('.yw-gallery-current');
    var total = nav.querySelector('.yw-gallery-total');
    var prev = nav.querySelector('.yw-gallery-prev');
    var next = nav.querySelector('.yw-gallery-next');

    function items() {
      return Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    }
    function activeIndex() {
      var its = items();
      for (var i = 0; i < its.length; i++) {
        if (its[i].classList.contains('is-active')) return i;
      }
      return 0;
    }
    // Desktop stacks the images and shows only .is-active. On mobile Dawn renders
    // a native horizontal scroll slider, so navigation there must also scroll the
    // target into view.
    function mediaList() {
      return gallery.querySelector('.product__media-list');
    }
    function isScrollSlider() {
      var l = mediaList();
      return !!(l && l.scrollWidth > l.clientWidth + 4);
    }
    function scrollToActive(target) {
      var l = mediaList();
      if (!l || !isScrollSlider() || !target) return;
      var lr = l.getBoundingClientRect();
      var tr = target.getBoundingClientRect();
      l.scrollTo({ left: l.scrollLeft + (tr.left - lr.left), behavior: 'smooth' });
    }
    function go(i) {
      var its = items();
      i = Math.max(0, Math.min(its.length - 1, i));
      var target = its[i];
      if (!target) return;
      // Toggle .is-active directly (drives the stacked desktop view + the counter).
      // NOT gallery.setActiveMedia() — that calls resetPages() which fires a
      // debounced slideChanged that reverts the image. On the mobile scroll slider
      // also bring the target into view.
      its.forEach(function (it) {
        it.classList.remove('is-active');
      });
      target.classList.add('is-active');
      scrollToActive(target);
      update();
    }
    function buildPagination() {
      pagination.innerHTML = '';

      items().forEach(function (_, index) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'yw-gallery-bullet';
        bullet.setAttribute('aria-label', 'View image ' + (index + 1));
        bullet.addEventListener('click', function () {
          go(index);
        });

        pagination.appendChild(bullet);
      });
    }
    function update() {
      var i = activeIndex();
      var n = items().length;
      current.textContent = i + 1;
      total.textContent = n;
      prev.disabled = i <= 0;
      next.disabled = i >= n - 1;
      nav.style.display = n > 1 ? '' : 'none';

      pagination.querySelectorAll('.yw-gallery-bullet').forEach(function (bullet, index) {
        bullet.classList.toggle('is-active', index === i);
      });
    }

    prev.addEventListener('click', function (e) {
      e.preventDefault();
      go(activeIndex() - 1);
    });
    next.addEventListener('click', function (e) {
      e.preventDefault();
      go(activeIndex() + 1);
    });
    var dragStartX = 0;
var dragStartY = 0;
var isDragging = false;

gallery.addEventListener('pointerdown', function (e) {
  if (e.pointerType === 'mouse' && e.button !== 0) return;

  dragStartX = e.clientX;
  dragStartY = e.clientY;
  isDragging = true;
  gallery.classList.add('yw-gallery-dragging');
});

gallery.addEventListener('pointerup', function (e) {
  if (!isDragging) return;

  var diffX = e.clientX - dragStartX;
  var diffY = e.clientY - dragStartY;

  isDragging = false;
  gallery.classList.remove('yw-gallery-dragging');

  // On the mobile scroll slider, native scrolling already handles the swipe —
  // don't double-navigate (the scroll listener keeps the counter in sync).
  if (isScrollSlider()) return;

  if (Math.abs(diffX) < 50 || Math.abs(diffX) < Math.abs(diffY)) return;

  if (diffX < 0) {
    go(activeIndex() + 1);
  } else {
    go(activeIndex() - 1);
  }
});

gallery.addEventListener('pointercancel', function () {
  isDragging = false;
  gallery.classList.remove('yw-gallery-dragging');
});
    // A variant change can switch the active image — keep the counter in sync.
    if (window.MutationObserver) {
      new MutationObserver(update).observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    // Keep the active image + counter in sync when the shopper scrolls the native
    // mobile slider, so the arrows always step from the image that's on screen.
    var syncRaf;
    function syncActiveFromScroll() {
      if (!isScrollSlider()) return;
      var l = mediaList();
      var its = items();
      if (!l || !its.length) return;
      var lr = l.getBoundingClientRect();
      var center = lr.left + lr.width / 2;
      var best = 0;
      var bestDist = Infinity;
      its.forEach(function (it, idx) {
        var r = it.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - center);
        if (d < bestDist) {
          bestDist = d;
          best = idx;
        }
      });
      if (!its[best].classList.contains('is-active')) {
        its.forEach(function (it, idx) {
          it.classList.toggle('is-active', idx === best);
        });
        update();
      }
    }
    var scrollHost = mediaList();
    if (scrollHost) {
      scrollHost.addEventListener(
        'scroll',
        function () {
          if (syncRaf) cancelAnimationFrame(syncRaf);
          syncRaf = requestAnimationFrame(syncActiveFromScroll);
        },
        { passive: true }
      );
    }

    buildPagination();
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.pdp-gallery media-gallery').forEach(initGallery);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
